// extracted by mini-css-extract-plugin
export var errorIcon = "_mt-1";
export var nameLogo = "_mt-0";